/**
 * PersonPill — Inline pill component for team member mentions in AI responses.
 *
 * Rendered by ChatMessage when ReactMarkdown encounters a `user:<zpuid>` link.
 * The `data-zpuid` attribute is exposed for future right-click / popover integration.
 */

interface PersonPillProps {
	zpuid: string;
	displayName: string;
}

export default function PersonPill({ zpuid, displayName }: PersonPillProps) {
	return (
		<span
			className="person-pill"
			data-zpuid={zpuid}
			aria-label={`Team member: ${displayName}`}
		>
			{/* Person icon — 12px inline SVG */}
			<svg
				viewBox="0 0 12 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				width="12"
				height="12"
				aria-hidden="true"
				style={{ flexShrink: 0 }}
			>
				<circle cx="6" cy="3.5" r="2.5" stroke="currentColor" strokeWidth="1.2" />
				<path
					d="M1 11c0-2.76 2.24-5 5-5s5 2.24 5 5"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
			</svg>
			{displayName}
		</span>
	);
}
